import humanSource from '../../components/Self/humanSource.vue'
import projectQuality from '../../components/Self/projectQuality.vue'
import finance from '../../components/Self/finance.vue'
import leaveStatistics from '../../components/Self/leaveStatistics.vue'
import constructionSchedule from '../../components/Self/constructionSchedule.vue'

export default {
  humanSource,
  projectQuality,
  finance,
  leaveStatistics,
  constructionSchedule
}



// WEBPACK FOOTER //
// ./src/assets/js/self.js